import React from 'react';
import { IllustrationSvg } from '../../../assets/svg/images';
import SandoogLogo from '../../../components/atoms/SandoogLogo';
import Seo from '../../../components/Seo';
import {
  StyledLoginInnerLayoutWrapper,
  StyledLoginInnerLayoutBox,
  StyledLoginInnerLayoutLogo,
  StyledLoginInnerLayoutHeading,
  StyledLoginInnerLayoutDecor,
  StyledLoginInnerLayoutHeadingWrapper,
  StyledLoginInnerLayoutSubtitle,
} from './styles';

import { LoginInnerLayoutProps } from './types';

const LoginInnerLayout: React.FC<LoginInnerLayoutProps> = ({
  title,
  subtitle,
  pageTitle,
  isBig,
  withDecor,
  children,
}) => (
  <>
    <Seo title={pageTitle || title || ''} />
    <StyledLoginInnerLayoutWrapper {...{ isBig }}>
      <StyledLoginInnerLayoutBox {...{ isBig }}>
        <StyledLoginInnerLayoutLogo>
          <SandoogLogo size={160} withText />
        </StyledLoginInnerLayoutLogo>
        {withDecor && (
          <StyledLoginInnerLayoutDecor>
            <IllustrationSvg />
          </StyledLoginInnerLayoutDecor>
        )}
        {title && (
          <StyledLoginInnerLayoutHeadingWrapper>
            {title && (
              <StyledLoginInnerLayoutHeading>
                {title}
              </StyledLoginInnerLayoutHeading>
            )}
          </StyledLoginInnerLayoutHeadingWrapper>
        )}
        {subtitle && (
          <StyledLoginInnerLayoutHeadingWrapper>
            {subtitle && (
              <StyledLoginInnerLayoutSubtitle>
                {subtitle}
              </StyledLoginInnerLayoutSubtitle>
            )}
          </StyledLoginInnerLayoutHeadingWrapper>
        )}
        {children}
      </StyledLoginInnerLayoutBox>
    </StyledLoginInnerLayoutWrapper>
  </>
);

export default LoginInnerLayout;
